import { render, staticRenderFns } from "./AppFeed.vue?vue&type=template&id=2563fbb8&"
import script from "./AppFeed.vue?vue&type=script&lang=js&"
export * from "./AppFeed.vue?vue&type=script&lang=js&"
import style0 from "./AppFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports